module.exports = __webpack_public_path__ + "static/media/jiaoyisuo.6992b7f1.png";